<template>
  <view-loader :loading="!!loading">
    <overproduction-search
        :date.sync="date"
        :disableSaveButtons="disableSaveButtons"
        @disableSaveButtons="onDisableSaveButtons"
        @searchOverproduction="onSearchOverproduction"
        @getBrands="onGetBrands"
        @getDeliveryType="onGetDeliveryType"
        @getFormDate="onGetFormDate"
    />

    <overproduction-table
        v-if="overproductionData.length"
        :overproductionData="overproductionData"
        @save="save"
    />

    <div v-else-if="wasSearched && !loading" class="alert alert-info">
      {{ trans('overproduction.empty_overproduction_planning') }}
    </div>

    <action-buttons
        :date.sync="date"
        :disableSaveButtons="disableSaveButtons"
        :sellBrands="sellBrands"
        :productionBrands="productionBrands"
        :deliveryType="deliveryType"
        :formDate="formDate"
        @sendToProduction="sendToProduction"
        @save="save"
    />

    <template #label>
      <h2>{{ trans('please_wait') }}...</h2>
    </template>
  </view-loader>
</template>

<script>
import OverproductionSearch from '@js/forms/overproduction/Search.vue'
import DateHelper from '@js/helpers/dateHelper'
import ViewLoader from '@component/ViewLoader.vue'
import OverproductionTable from '@js/forms/overproduction/OverproductionTable.vue'
import axios from 'axios'
import ActionButtons from '@js/forms/overproduction/ActionButtons.vue'
import toastr from '@js/toastr'

export default {
  name: 'OverproductionPlanning',
  components: {
    OverproductionSearch,
    ViewLoader,
    OverproductionTable,
    ActionButtons
  },
  data() {
    return {
      date: DateHelper.format(new Date()),
      loading: false,
      overproductionData: [],
      wasSearched: false,
      disableSaveButtons: false,
      sellBrands: [],
      productionBrands: [],
      deliveryType: '',
      formDate: DateHelper.format(new Date()),
    }
  },
  methods: {
    onSearchOverproduction(value) {
      const {queryParams: {date}} = value
      const {queryStringParams} = value

      this.loading = true
      this.disableSaveButtons = false
      this.overproductionData = []
      this.date = date

      const routingSearch = Routing.generate('api_overproduction_production_list', {
        date: date,
      })

      axios.get(routingSearch, {params: queryStringParams}).then(response => {
        if (response.data && response.data.length) {
          this.overproductionData = Object.values(response.data)
          if (queryStringParams.sellBrands.length === 0) {
            this.disableSaveButtons = true;
          }
        } else {
          this.wasSearched = true
        }
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.loading = false
      })
    },
    sendToProduction(value) {
      this.loading = true

      const requestBody = {
        dateType: value.dateType,
        sellBrands: value.sellBrands,
        productionBrands: value.productionBrands,
        items: this.overproductionData
      }

      requestBody.items = this.overproductionData

      const routingSave = Routing.generate('api_post_production_list_save_overproduction_and_generate_production_list', {
        date: value.date,
      })

      axios.post(routingSave, requestBody).then(() => {
        toastr.success(window.Translator.trans('overproduction.flash.save'))
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        const overproductionSearchParams = {
          queryStringParams: {
            dateType: requestBody.dateType,
            sellBrands: requestBody.sellBrands,
            productionBrands: requestBody.productionBrands,
          },
          queryParams: {
            date: value.date
          }
        }

        this.onSearchOverproduction(overproductionSearchParams)
      })
    },
    save(item) {
      const routingSave = Routing.generate('api_put_production_list_save_overproduction', {
        date: this.date,
      })

      axios.put(routingSave, {item: item}).then(() => {
        toastr.success(window.Translator.trans('overproduction.flash.save'))
      }, response => {
        this.handleAjaxError(response)
      })
    },
    onDisableSaveButtons(value) {
      this.disableSaveButtons = value
    },
    onGetBrands(value) {
      this.sellBrands = value.sellBrands;
      this.productionBrands = value.productionBrands;
    },
    onGetDeliveryType(value) {
      this.deliveryType = value
    },
    onGetFormDate(value) {
      this.formDate = value
    },
  }
}
</script>
